import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type IFlameSignalData } from '../services/getFlameSignaGraphKPIDataService'

export interface IFlameSignalDataState {
  isLoading: boolean
  error: string | null
  signalData: any | null
  httpStatus: number | undefined
}

const initialState: IFlameSignalDataState = {
  isLoading: false,
  error: null,
  signalData: null,
  httpStatus: 0
}

const flowSignalKpiDataSlice = createSlice({
  name: 'flowSignalKpiData',
  initialState,
  reducers: {
    flowSignalKPIDataLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        signalData: null,
        httpStatus: 0
      }
    },
    flowSignalKPIDataUpdateAction: (state, action: PayloadAction<{ data: IFlameSignalData, httpStatus: number }>) => {
      console.log(action, 'datadatasa')
      return {
        isLoading: false,
        error: null,
        signalData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    flowSignalKPIDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        signalData: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  flowSignalKPIDataLoadingAction,
  flowSignalKPIDataUpdateAction,
  flowSignalKPIDataErrorAction
} = flowSignalKpiDataSlice.actions

export default flowSignalKpiDataSlice.reducer
